import { Component } from '@angular/core';
import { ScreenAnalyticsDirective } from '@flyfreely-portal-ui/analytics';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
    EVENT_ENHANCED_HELP_OFF,
    EVENT_ENHANCED_HELP_ON
} from '../enhanced-help.service';

@Component({
    selector: 'enhanced-help-switch',
    templateUrl: './enhanced-help-switch.component.html',
    styleUrls: [`./styles.scss`]
})
export class EnhancedHelpSwitch {
    active: boolean;

    private ngUnsubscribe$ = new Subject<void>();

    constructor(private screenAnalytics: ScreenAnalyticsDirective) {}

    ngOnInit() {
        // set the initial state of enhanced help across screens
        this.screenAnalytics.helpActive$
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(active => {
                if (this.active !== active) {
                    this.active = active;
                }
            });
    }

    ngOnDestroy() {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    toggleEnhancedHelp() {
        this.screenAnalytics.track(
            'help',
            this.active ? EVENT_ENHANCED_HELP_ON : EVENT_ENHANCED_HELP_OFF
        );
        this.screenAnalytics.setHelpActive(this.active);
    }
}
